// Salesforce lead-eligibility rule definitions shared by the Sendora dashboard
// (client-side filtering of synced members) and the Campaign Contact Uploader
// (server-side filtering before campaign members are created). Keys and labels
// must stay in sync with blocks-backend/controllers/landmark/salesforceLeadFilters.js.

export const SALESFORCE_FILTER_TOGGLE_KEYS = {
  EMAIL_OPT_OUT: "emailOptOut",
  STATUS: "status",
  DNC_SUMMIT_EVENTS: "dncSummitEvents",
  EMAIL_BOUNCED: "emailBounced",
  ACCOUNT_STATUS: "accountStatus",
  PENDING_EVENTS: "pendingEvents",
  ACTIVE_OPPORTUNITIES: "activeOpportunities",
  DNC_EVENTS: "dncEvents",
  DNC_CURATE: "dncCurate",
  EVENTS_DNCS_REMOVES: "eventsDncsRemoves",
  EMAIL_STATUS: "emailStatus",
  HAS_OPPORTUNITIES: "hasOpportunities",
};

export const DEFAULT_SALESFORCE_FILTER_TOGGLES = {
  [SALESFORCE_FILTER_TOGGLE_KEYS.EMAIL_OPT_OUT]: true,
  [SALESFORCE_FILTER_TOGGLE_KEYS.STATUS]: true,
  [SALESFORCE_FILTER_TOGGLE_KEYS.DNC_SUMMIT_EVENTS]: true,
  [SALESFORCE_FILTER_TOGGLE_KEYS.EMAIL_BOUNCED]: true,
  [SALESFORCE_FILTER_TOGGLE_KEYS.ACCOUNT_STATUS]: true,
  [SALESFORCE_FILTER_TOGGLE_KEYS.PENDING_EVENTS]: true,
  [SALESFORCE_FILTER_TOGGLE_KEYS.ACTIVE_OPPORTUNITIES]: true,
  [SALESFORCE_FILTER_TOGGLE_KEYS.DNC_EVENTS]: true,
  [SALESFORCE_FILTER_TOGGLE_KEYS.DNC_CURATE]: true,
  [SALESFORCE_FILTER_TOGGLE_KEYS.EVENTS_DNCS_REMOVES]: true,
  [SALESFORCE_FILTER_TOGGLE_KEYS.EMAIL_STATUS]: true,
  [SALESFORCE_FILTER_TOGGLE_KEYS.HAS_OPPORTUNITIES]: true,
};

// Display order matches the "Salesforce lead filters" modal in Sendora.
export const SALESFORCE_FILTER_RULE_DEFS = [
  {
    key: SALESFORCE_FILTER_TOGGLE_KEYS.EMAIL_OPT_OUT,
    label: "Email Opt Out equals False",
  },
  {
    key: SALESFORCE_FILTER_TOGGLE_KEYS.EMAIL_BOUNCED,
    label: "Email Bounced equals False",
  },
  {
    key: SALESFORCE_FILTER_TOGGLE_KEYS.EMAIL_STATUS,
    label: 'Email Status equals Accept All, Verified, antispam_system, smtp_protocol, ""',
  },
  {
    key: SALESFORCE_FILTER_TOGGLE_KEYS.STATUS,
    label: 'Status equals Dealmaking, Engaged, ""',
  },
  {
    key: SALESFORCE_FILTER_TOGGLE_KEYS.ACCOUNT_STATUS,
    label: 'Account Status equals Active, Research/Vendor, ""',
  },
  {
    key: SALESFORCE_FILTER_TOGGLE_KEYS.PENDING_EVENTS,
    label: "Pending Events does not contain linked Salesforce campaign title",
    usesCampaignName: true,
    labelPrefix: "Pending Events does not contain",
  },
  {
    key: SALESFORCE_FILTER_TOGGLE_KEYS.ACTIVE_OPPORTUNITIES,
    label: "Active Opportunities does not contain linked Salesforce campaign title",
    usesCampaignName: true,
    labelPrefix: "Active Opportunities does not contain",
  },
  {
    key: SALESFORCE_FILTER_TOGGLE_KEYS.DNC_EVENTS,
    label: "DNC - Events equals False",
  },
  {
    key: SALESFORCE_FILTER_TOGGLE_KEYS.DNC_SUMMIT_EVENTS,
    label: "DNC - Summit Events equals False",
  },
  {
    key: SALESFORCE_FILTER_TOGGLE_KEYS.DNC_CURATE,
    label: "DNC - Curate equals False",
  },
  {
    key: SALESFORCE_FILTER_TOGGLE_KEYS.EVENTS_DNCS_REMOVES,
    label: 'Events DNCs Removes does not contain "123456"',
  },
  {
    key: SALESFORCE_FILTER_TOGGLE_KEYS.HAS_OPPORTUNITIES,
    label: "Has Opportunities equals False",
  },
];

// Label for a rule; the two campaign-name rules show the actual campaign name
// when one is known (e.g. `Pending Events does not contain "5-6-26 Julie ..."`).
export function getSalesforceLeadFilterRuleLabel(rule = {}, campaignName = "") {
  if (!rule?.usesCampaignName) return String(rule?.label || "");
  const name = String(campaignName || "").trim();
  return name ? `${rule.labelPrefix} "${name}"` : String(rule?.label || "");
}

export function getSalesforceLeadFilterRuleLabelByKey(key = "", campaignName = "") {
  const rule = SALESFORCE_FILTER_RULE_DEFS.find((def) => def.key === key);
  return rule ? getSalesforceLeadFilterRuleLabel(rule, campaignName) : String(key || "");
}
